import { render, staticRenderFns } from "./SimplingDetails.vue?vue&type=template&id=4d649700&scoped=true&"
import script from "./SimplingDetails.vue?vue&type=script&lang=js&"
export * from "./SimplingDetails.vue?vue&type=script&lang=js&"
import style0 from "./SimplingDetails.vue?vue&type=style&index=0&id=4d649700&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d649700",
  null
  
)

export default component.exports